// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Box, Button, Divider, Flex, HStack, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Dialog, Icon, Lottie, Tag } from "components"

// Hooks
import { useOrder } from "hooks"
import { Enums } from "config"
import { API } from "config"

export default function Fiscal({ data, step, setStep }){

    const order = useOrder(data?.id)
    const confirm = useDisclosure()
    const [ loading, setLoading ] = useState(false)

    const fiscal = order.data?.fiscal?.filter(item => item.status === Enums.FiscalNoteStatus.GENERATED)?.[0]

    return(
    <>
    <Flex gridTemplateColumns="1fr 1fr" gap={8} justifyContent="center" alignItems="center" p={8}>
        
        <Box w="70%" borderWidth={1} p={8} borderRadius={4} borderStyle="dashed" borderColor={!fiscal ? '' : 'teal'}>
            <Flex alignItems="center" justifyContent="center" direction="column">
                <Icon name="pdf" fontSize={30} />
                <Text fontSize="1.2rem" fontWeight="bold">Nota fiscal</Text>
                <Tag size="sm" children={!fiscal ? 'Aguardando emissão' : 'Disponível'} mb={3} colorScheme={!fiscal ? 'red' : 'teal'} />
                <Text fontSize="sm" children="Aqui você pode visualizar e imprimir a nota fiscal do pedido." color="GrayText" /> 
                <Button mt={4} children="Download da Nota Fiscal" isDisabled={!fiscal} leftIcon={<Icon name="pdf" />} onClick={() => window.open(fiscal?.pdf?.download_url)} />
            </Flex>
        </Box>

        <Box w="70%" borderWidth={1} p={8} borderRadius={4} borderStyle="dashed" borderColor="teal">
            <Flex alignItems="center" justifyContent="center" direction="column">
                <Icon name="fiscal" fontSize={30} />
                <Text fontSize="1.2rem" fontWeight="bold">Etiqueta</Text>
                <Tag size="sm" children="Pronta para impressão" mb={3} colorScheme="teal" />
                <Text fontSize="sm" children="Aqui você pode visualizar e imprimir a etiqueta de envio do pedido." color="GrayText" />
                <Button mt={4} children="Imprimir etiqueta" leftIcon={<Icon name="print" />} colorScheme="teal" onClick={() => window.open(order.data?.label_url)} />
            </Flex>
        </Box>

    </Flex>

    <Divider my={4} />

    <Flex alignItems="center" justifyContent="center" w="100%" py={6}>
        <Stack w="50%">
            <Button children="Enviar para coleta" leftIcon={<Icon name="transfer" />} size="lg" colorScheme="orange" isDisabled={order.isFetching || !fiscal} onClick={confirm.onOpen} />
            <Text textAlign="center" color="GrayText" children="Após impressão da etiqueta e nota fiscal, marque o pedido para ser coletado pela transportadora escolhida ou para retirada pelo cliente." />
        </Stack>
    </Flex>

    {/* Confirm */}
    <ConfirmAlert {...confirm} data={order.data} onSuccess={order.refetch} />
    </>
    )
}

const ConfirmAlert = ({ data, onSuccess = () => {}, ...props }) => {

    const toast = useToast()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!window.confirm('Certeza que deseja continuar?')) return
        setLoading(true)

        try{
            await API.post(`/orders/${data?.id}/collect`)
            toast({ title: 'Operação realizada com sucesso!', status: 'success' })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível continuar', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Dialog title={`Enviar pedido #${data?.cod} para coleta?`} loading={loading} {...props}>
        <AlertDialogBody fontSize="sm">
            Ao confirmar esta ação, você estará confirme que a nota fiscal foi gerada e o pedido está devidamente etiquetado para envio pela transportadora ou retirada pelo cliente.
        </AlertDialogBody>
        <AlertDialogFooter>
            <Button w="100%" children="Enviar para coleta" colorScheme="orange" rightIcon={<Icon name="right" />} onClick={handleSubmit} isLoading={loading} />
        </AlertDialogFooter>
    </Dialog>
    )
}